import React from "react";
import ListData from "./ListData";

const ListErrorTaxDeduct = props => {
  return <ListData isTaxDeduct />;
};

export default ListErrorTaxDeduct;
